import{classAdderBuilder as s}from"../../common/dist/classadder/classAdderBuilder.js";s({class:"mdc-deprecated-list-item__secondary-text",tag:"span"});
//# sourceMappingURL=SecondaryText.js.map
